/* J·SKIN LAB — /pages/dobor, kreator 2.0 (jsl10s, runda 5, 24.09.2026): od razu okienka z propozycją → zapis → kosmetolog.
   Nie ma już quizu krok po kroku: pytania (strefa, cera, problem, na co uważać) są przełącznikami w panelu kreatora,
   a każda odpowiedź od razu przestawia propozycje w okienkach. Silnik: assets/jsl10s-kreator.js na danych assets/jsl10s-rutyny.json.
   Zapis: parametry w adresie (?s=&c=&p=&u=&z=&w=), localStorage „jsl-dobor-2026” (odpowiedzi i warianty — bez danych osobowych),
   druk/PDF przez @media print. Formularz: natywny contact Shopify; skrypt wypełnia tylko ukryte pola z rutyną. */
(function () {
  'use strict';
  var root = document.querySelector('[data-jsl-dobor]');
  if (!root) return;
  var D; try { D = JSON.parse(root.querySelector('.js-dob__dane').textContent); } catch (e) { return; }
  var X = D.d || {}, T = D.t || {}, KL = 'jsl-dobor-2026';
  var $ = function (s, r) { return (r || root).querySelector(s); };
  function tx(s, o) { s = s || ''; if (o) for (var k in o) s = s.split('{' + k + '}').join(o[k]); return s; }
  function czytaj() { try { return JSON.parse(localStorage.getItem(KL)) || null; } catch (e) { return null; } }
  function zapisz(o) { try { localStorage.setItem(KL, JSON.stringify(o)); } catch (e) { /* tryb prywatny */ } }
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var bibP = fetch(root.dataset.rutyny, { credentials: 'same-origin' }).then(function (o) { if (!o.ok) throw new Error(o.status); return o.json(); });

  // ── odpowiedzi ──
  var STREFY = ['twarz', 'cialo', 'wlosy', 'stopy'];
  var WYKL = { ciaza: ['p', 'r'], retinoidy: ['r', 'k'], zabieg: ['r', 'k'], alergia: [] };
  var odp = { s: 'twarz', c: '', p: '', u: [], z: 'pelna' };
  // PRAW2 (25.09): odpowiedzi o skórze, które mogą ujawniać stan zdrowia (cera atopowa; trądzik, łojotok, naczynka i rumień), traktujemy jak
  // „Unikam”: służą doborowi na urządzeniu, ale nie trafiają do adresu strony, linku rutyny, pola „Odpowiedzi” ani do newslettera (jsl-zapis.js);
  // do kosmetologa idą tylko po osobnej zgodzie (art. 9 ust. 2 lit. a RODO). Ta sama lista jest w jsl-zapis.js.
  var ZDR_C = { a: 1 }, ZDR_P = { t: 1, l: 1, n: 1 };
  function zdrC(c) { return !!ZDR_C[String(c || '').toLowerCase()]; }
  function zdrP(p) { return !!ZDR_P[String(p || '')]; }
  function zle() { var o = []; odp.u.forEach(function (u) { (WYKL[u] || []).forEach(function (f) { if (o.indexOf(f) < 0) o.push(f); }); }); return o; }
  function etykiety() {
    var o = [];
    if (odp.s) o.push((X.s || {})[odp.s]);
    if (odp.c && !zdrC(odp.c)) o.push((T.cery || {})[odp.c] || odp.c);
    if (odp.p && !zdrP(odp.p)) o.push((T.problemy || {})[odp.p] || odp.p);
    if (K && K.zakresy().length > 1) o.push(T['z_' + odp.z] || odp.z);
    return o.filter(Boolean);
  }
  // PRAW1 (25.09): informacje o zdrowiu (ciąża, retinoidy, zabieg, alergia) są osobno — nie trafiają do adresu strony, linku rutyny
  // ani tagów newslettera; do kosmetologa idą tylko po zaznaczeniu osobnej zgody (art. 9 ust. 2 lit. a RODO) przy formularzu.
  function etykietyZdrowie() {
    var o = odp.u.map(function (u) { return (X.uw || {})[u]; });
    if (zdrC(odp.c)) o.push((T.cery || {})[odp.c] || odp.c);
    if (zdrP(odp.p)) o.push((T.problemy || {})[odp.p] || odp.p);
    return o.filter(Boolean);
  }

  var K = null, bib = null, kreatorBox = $('.js-dob__kreator'), ladowanie = $('.js-dob__ladowanie');
  var uwaga = $('.js-dob__uwaga'), uwagaTx = uwaga.querySelector('span'), przyw = $('.js-dob__przyw');
  function rysujUwage() {
    var n = [], f = zle();
    if (f.length) n.push(tx(X.uwaga_wyklucz, { x: f.map(function (c) { return (T.zaw || {})[c] || c; }).join(', ') }));
    if (odp.u.indexOf('ciaza') >= 0) n.push(X.uwaga_ciaza);
    if (odp.u.indexOf('zabieg') >= 0) n.push(X.uwaga_zabieg);
    if (odp.u.indexOf('alergia') >= 0) n.push(X.uwaga_alergia);
    uwaga.hidden = !n.length;
    uwagaTx.textContent = n.join(' ');
  }
  function zbuduj(warianty) {
    var z = bib.strefy[odp.s] || bib.strefy.twarz;
    if (!bib.strefy[odp.s]) odp.s = 'twarz';
    var cfg = {}; for (var a in D.cfg) cfg[a] = D.cfg[a];
    cfg.strefa = odp.s; cfg.kroki = z.kroki; cfg.cery = z.cery.toUpperCase(); cfg.problemy = z.problemy; cfg.img = bib.img;
    cfg.prezenty = D.prezenty; cfg.nazwy = D.nazwy; cfg.klucz = 'jsl-kreator2';
    cfg.bar2 = { cel: '#dobor-wyslij', tekst: X.bar_wyslij };
    cfg.panelOtwarty = true; cfg.zakres = odp.z;
    cfg.lCera = odp.s === 'twarz' ? '' : X.twoja_skora;
    cfg.strefy = STREFY.filter(function (s) { return bib.strefy[s]; }).map(function (s) { return { id: s, t: (X.s || {})[s] || s }; });
    cfg.uwagi = Object.keys(WYKL).map(function (u) { return { id: u, t: (X.uw || {})[u] || u, zle: WYKL[u] }; });
    cfg.naStrefe = function (s, f) { odp.s = s; odp.c = f.cera; odp.p = f.prob; odp.u = f.uw; odp.z = 'pelna'; zbuduj(null); };
    var el = document.createElement('div'); el.className = 'jsl-kre4'; el.id = 'jsl-kreator';
    kreatorBox.innerHTML = ''; kreatorBox.appendChild(el);
    K = window.JslKreator.utworz(el, cfg, T);
    K.ustawFiltry({ cera: odp.c, prob: odp.p, uw: odp.u });
    if (warianty && warianty.length) K.wybierz(warianty);
    if (K.akcje) {
      K.akcje.innerHTML = '<a class="jsl-kpods__akc" href="#dobor-zapisz">' + window.JslKreator.ikona('link', 16) + '<span>' + esc(X.akcja_zapisz) + '</span></a>'
        + '<a class="jsl-kpods__akc jsl-kpods__akc--2" href="#dobor-wyslij">' + window.JslKreator.ikona('plus', 16) + '<span>' + esc(X.akcja_wyslij) + '</span></a>';
    }
    K.naZmiane(poZmianie);
    poZmianie(K.stan());
  }
  function start(warianty, cel) {
    ladowanie.hidden = false;
    var gotowy = window.JslKreator && window.JslKreator.v === 2 ? Promise.resolve() : new Promise(function (ok) { window.addEventListener('load', ok, { once: true }); });
    return Promise.all([bibP, gotowy]).then(function (w) {
      bib = w[0]; ladowanie.hidden = true;
      zbuduj(warianty);
      if (cel) { var c = document.querySelector(cel); if (c) window.scrollTo({ top: window.scrollY + c.getBoundingClientRect().top - 80, behavior: 'auto' }); }
    }).catch(function () { ladowanie.hidden = false; ladowanie.textContent = X.blad; });
  }

  // ── zapis: adres, pamięć, formularz ──
  var linkIn = $('#dobor-link');
  function adres(S) {
    var q = new URLSearchParams();
    q.set('s', odp.s);
    if (odp.c && !zdrC(odp.c)) q.set('c', odp.c); if (odp.p && !zdrP(odp.p)) q.set('p', odp.p);
    q.set('z', odp.z);
    var w = S.wybrane.map(function (x) { return x.x.v; });
    if (w.length) q.set('w', w.join(','));
    return location.origin + location.pathname + '?' + q.toString();
  }
  function poZmianie(S) {
    odp.c = S.filtry.cera; odp.p = S.filtry.prob; odp.u = S.filtry.uw; odp.z = S.zakres;
    rysujUwage();
    var u = adres(S);
    if (linkIn) linkIn.value = u;
    try { history.replaceState(null, '', u.replace(location.origin, '') + (location.hash && location.hash !== '#wyslij' ? location.hash : '')); } catch (e) { /* stary silnik */ }
    zapisz({ odp: odp, w: S.wybrane.map(function (x) { return x.x.v; }) });
    var f = document.getElementById('JsForm-dobor');
    if (!f) return;
    var pole = function (n) { return f.querySelector('[data-dob="' + n + '"]'); };
    if (pole('odpowiedzi')) pole('odpowiedzi').value = etykiety().join(' · ');
    zdrowiePola();
    if (pole('rutyna')) pole('rutyna').value = S.wybrane.map(function (w) { return w.nr + '. ' + w.krok + ': ' + w.x.m + ' — ' + w.nazwa + (w.c != null ? ' — ' + S.fmt(w.c) : '') + ' — /products/' + w.x.h; }).join('\n')
      + (S.prezent ? '\n+ ' + (T.prezent || '') + ': ' + S.prezent.x.m + ' ' + S.prezent.x.t : '') + (S.n ? '\n= ' + S.fmt(S.po) : '');
    if (pole('link')) pole('link').value = u;
    var dl = pole('dolacz');
    if (dl) dl.textContent = S.n ? tx(X.f_dolaczona, { x: S.n + ' ' + ((T.prep || {})[(window.Intl && Intl.PluralRules ? new Intl.PluralRules(D.cfg.loc).select(S.n) : 'other')] || '') + ' · ' + S.fmt(S.po) }) : X.f_pusta;
  }
  function zdrowiePola() {
    var f = document.getElementById('JsForm-dobor');
    if (!f) return;
    var box = f.querySelector('[data-dob="zdrowie-box"]'), zg = f.querySelector('[data-dob="zdrowie-zgoda"]'), pole = f.querySelector('[data-dob="zdrowie"]'), lista = f.querySelector('[data-dob="zdrowie-lista"]');
    if (!box || !zg || !pole) return;
    var z = etykietyZdrowie();
    box.hidden = false; // PRAW2: zgoda widoczna zawsze — obejmuje też informacje o zdrowiu wpisane w wiadomości
    if (lista) lista.textContent = z.join(', ');
    zg.disabled = false;
    pole.value = zg.checked ? (z.length ? z.join(' · ') + ' · ' : '') + 'zgoda obejmuje też treść wiadomości' : '';
    pole.disabled = !zg.checked;
  }
  (function () {
    var f = document.getElementById('JsForm-dobor'), zg = f && f.querySelector('[data-dob="zdrowie-zgoda"]');
    if (zg) zg.addEventListener('change', zdrowiePola);
    // PRAW2 (26.09): wiadomość z informacjami o zdrowiu nie wychodzi bez zgody — prosta kontrola słów (PL, EN, DE). Heurystyka: nie łapie wszystkiego,
    // dlatego pod polem jest podpowiedź, a polityka prywatności opisuje postępowanie, gdy takie informacje mimo to dotrą bez zgody.
    var tr = f && f.querySelector('textarea[name="contact[body]"]'), al = f && f.querySelector('[data-dob="zdrowie-alert"]');
    if (!tr || !zg) return;
    var ZDR_SLOWA = /(ciąż|ciaz[ayęe]|karmi\S* piersi|alergi|uczul|atopow|\bazs\b|trądzik|tradzik|łojotok|lojotok|łuszczyc|luszczyc|egzem|wyprysk|rumie[nń]|chorob|\bchor[ayeą]\b|\bleki\b|\bleków\b|lekarstw|leczę|leczen|leczon|izotretynoin|antybiotyk|hormon|tarczyc|cukrzyc|nadciśnieni|nowotw|chemioterap|pregnan|breastfeed|allerg|eczema|dermatitis|\bacne\b|rosacea|psoriasis|medication|isotretinoin|disease|schwanger|stillzeit|neurodermitis|ekzem|\bakne\b|rosazea|schuppenflechte|medikament|krankheit|erkrank)/i;
    f.addEventListener('submit', function (e) {
      if (zg.checked || !ZDR_SLOWA.test(tr.value)) { if (al) al.hidden = true; return; }
      e.preventDefault();
      if (al) al.hidden = false;
      zg.focus();
    });
    tr.addEventListener('input', function () { if (al && !al.hidden && !ZDR_SLOWA.test(tr.value)) al.hidden = true; });
  })();
  var kop = $('.js-dob__kopiuj');
  kop.addEventListener('click', function () {
    var ok = function () { kop.textContent = X.skopiowano; kop.classList.add('is-ok'); setTimeout(function () { kop.textContent = X.kopiuj; kop.classList.remove('is-ok'); }, 2200); };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(linkIn.value).then(ok, function () { linkIn.select(); document.execCommand('copy'); ok(); });
    else { linkIn.select(); try { document.execCommand('copy'); ok(); } catch (e) { /* zaznaczony — skopiuje ręcznie */ } }
  });
  linkIn.addEventListener('focus', function () { linkIn.select(); });

  // ── druk / PDF: osobny, prosty arkusz dodany do body tylko na czas drukowania ──
  var druk = null;
  function zbudujDruk() {
    if (!K) return;
    var S = K.stan();
    if (!druk) { druk = document.createElement('div'); druk.className = 'js-druk'; document.body.appendChild(druk); }
    var d = new Date();
    druk.innerHTML = '<header class="js-druk__gl"><b>J·SKIN LAB</b><span>' + esc(X.wynik_e) + ' · ' + esc(d.toLocaleDateString(D.cfg.loc)) + '</span></header>'
      + '<p class="js-druk__odp"><b>' + esc(X.druk_odp) + ':</b> ' + esc(etykiety().concat(etykietyZdrowie()).join(' · ')) + '</p>'
      + '<ol class="js-druk__lista">' + S.wybrane.map(function (w) {
        return '<li><div class="js-druk__k">' + esc(w.krok) + '</div><div class="js-druk__p"><small>' + esc(w.x.m) + '</small><b>' + esc(w.nazwa) + '</b>'
          + (D.cfg.pl && w.d ? '<p><i>' + esc(X.jak) + ':</i> ' + esc(w.d) + '</p>' : '') + '</div><div class="js-druk__c">' + (w.c != null ? esc(S.fmt(w.c)) : '') + '</div></li>';
      }).join('') + '</ol>'
      + (S.n ? '<p class="js-druk__suma"><span>' + esc(T.do_zaplaty || '') + '</span><b>' + esc(S.fmt(S.po)) + '</b></p>' : '')
      + '<footer class="js-druk__st"><span>' + esc(X.druk_link) + ': ' + esc(linkIn.value) + '</span><span>' + esc(X.druk_pyt) + '</span></footer>';
    document.documentElement.classList.add('js-drukuje');
  }
  window.addEventListener('beforeprint', zbudujDruk);
  window.addEventListener('afterprint', function () { document.documentElement.classList.remove('js-drukuje'); });
  $('.js-dob__drukuj').addEventListener('click', function () { zbudujDruk(); window.print(); });

  // ── start: link z rutyną → ta rutyna; zapisana w przeglądarce → ta rutyna + „Zacznij od nowa”; inaczej od razu propozycja ──
  var q = new URLSearchParams(location.search), zap = czytaj();
  var wyslane = !!$('.js-dob__dzieki'), bladForm = !!$('#JsForm-dobor .js-komunikat--blad');
  function zPamieci() { if (zap && zap.odp) { odp = zap.odp; odp.u = odp.u || []; odp.s = odp.s || 'twarz'; odp.z = odp.z || 'pelna'; return zap.w || []; } return []; }
  var zak = function (z) { return z === 'min' ? 'rano' : (['pelna', 'rano', 'wieczor', 'oczyszczanie'].indexOf(z) >= 0 ? z : 'pelna'); };
  var cel = (wyslane || bladForm || location.hash === '#wyslij') ? '#dobor-wyslij' : null;
  if (q.get('s')) {
    odp.s = q.get('s'); odp.c = (q.get('c') || '').toUpperCase(); odp.p = q.get('p') || '';
    odp.u = (q.get('u') || '').split(',').filter(function (u) { return WYKL[u]; }); odp.z = zak(q.get('z'));
    start((q.get('w') || '').split(',').filter(Boolean), cel);
  } else if (zap && zap.odp) {
    var w0 = zPamieci(); odp.z = zak(odp.z);
    start(w0, cel).then(function () {
      if (!cel && w0.length) przyw.hidden = false;
      if (wyslane) { var d = $('.js-dob__dzieki'); if (d) d.focus({ preventScroll: true }); }
    });
  } else {
    // bez odpowiedzi: cera i problem z karty produktu (jeśli klientka je tam ustawiła), reszta — propozycja ogólna
    var f0 = {}; try { f0 = JSON.parse(localStorage.getItem('jsl-kreator2')) || {}; } catch (e) { /* brak */ }
    odp.c = f0.c || ''; odp.p = f0.p || ''; odp.u = (f0.uw || []).filter(function (u) { return WYKL[u]; });
    start(null, cel);
  }
  $('.js-dob__odnowa').addEventListener('click', function () {
    przyw.hidden = true;
    odp = { s: odp.s, c: '', p: '', u: [], z: 'pelna' };
    try { localStorage.removeItem(KL); } catch (e) { /* tryb prywatny */ }
    zbuduj(null);
  });
})();
